import React from 'react';
import { Container } from '@mui/material';
import './style.css';

interface DashboardProps {
  students: React.ReactNode;
  header?: React.ReactNode;  // Full-width header
  constrained?: boolean;     // Whether main content should be constrained
}

const Dashboard: React.FC<DashboardProps> = ({ students, header, constrained = false }) => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        {header && header}  {/* Header stays full width */}
        {constrained ? (
          <Container maxWidth="lg">{students}</Container>
        ) : (
          students
        )}
      </div>
    </div>
  );
};

export default Dashboard;